var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgServerErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118,
    height: 112
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "ServerErrorIcon_svg__c",
    cx: 65,
    cy: 91,
    rx: 46,
    ry: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ServerErrorIcon_svg__e",
    cx: 23,
    cy: 38,
    rx: 14,
    ry: 3
  }), /*#__PURE__*/React.createElement("filter", {
    id: "ServerErrorIcon_svg__d",
    width: "103%",
    height: "150%",
    x: "-2%",
    y: "-25%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    values: "0 0 0 0 0.941176471 0 0 0 0 0.956862745 0 0 0 0 0.968627451 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ServerErrorIcon_svg__f",
    width: "111%",
    height: "160%",
    x: "-6%",
    y: "-30%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    values: "0 0 0 0 0.941176471 0 0 0 0 0.956862745 0 0 0 0 0.968627451 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "ServerErrorIcon_svg__a",
    width: 108,
    height: 72,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ServerErrorIcon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ServerErrorIcon_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#EBF7FE",
    xlinkHref: "#ServerErrorIcon_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#459FED",
    mask: "url(#ServerErrorIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(52 34)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    y: 19,
    rx: 2
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ServerErrorIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#459FED",
    d: "M0 3c0-2 1-3 3-3h102c2 0 3 1 3 3v16H0V3z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 7)",
    fill: "#EBF7FE"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 3,
    r: 3
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF7FE",
    d: "M35 10c0-2 1-3 3-3h59c2 0 3 1 3 3 0 1-1 2-3 2H38c-2 0-3-1-3-2z"
  }))), /*#__PURE__*/React.createElement("use", {
    fill: "#EAF7FF",
    xlinkHref: "#ServerErrorIcon_svg__c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#ServerErrorIcon_svg__d)",
    xlinkHref: "#ServerErrorIcon_svg__c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92 72)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#DAEAF3",
    xlinkHref: "#ServerErrorIcon_svg__e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#ServerErrorIcon_svg__f)",
    xlinkHref: "#ServerErrorIcon_svg__e"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9DD7F9",
    strokeWidth: 3,
    d: "M28 34a4 4 0 100-9m0 0H8c-4 0-8-3-8-6V0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7E3FA",
    d: "M17 30h8c2 0 4 2 4 4s-2 4-4 4h-8v-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8FD6F9",
    d: "M17 30h3v8h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3899EC",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M18 32h-4m4 4h-4"
  })))));
}

export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='118' height='112'%3e %3cdefs%3e %3crect id='a' width='108' height='72' rx='4'/%3e %3cellipse id='c' cx='65' cy='91' rx='46' ry='3'/%3e %3cfilter id='d' width='103%25' height='150%25' x='-2%25' y='-25%25' filterUnits='objectBoundingBox'%3e %3cfeGaussianBlur in='SourceAlpha' result='shadowBlurInner1' stdDeviation='2'/%3e %3cfeOffset in='shadowBlurInner1' result='shadowOffsetInner1'/%3e %3cfeComposite in='shadowOffsetInner1' in2='SourceAlpha' k2='-1' k3='1' operator='arithmetic' result='shadowInnerInner1'/%3e %3cfeColorMatrix in='shadowInnerInner1' values='0 0 0 0 0.941176471 0 0 0 0 0.956862745 0 0 0 0 0.968627451 0 0 0 1 0'/%3e %3c/filter%3e %3cellipse id='e' cx='23' cy='38' rx='14' ry='3'/%3e %3cfilter id='f' width='111%25' height='160%25' x='-6%25' y='-30%25' filterUnits='objectBoundingBox'%3e %3cfeGaussianBlur in='SourceAlpha' result='shadowBlurInner1' stdDeviation='2'/%3e %3cfeOffset in='shadowBlurInner1' result='shadowOffsetInner1'/%3e %3cfeComposite in='shadowOffsetInner1' in2='SourceAlpha' k2='-1' k3='1' operator='arithmetic' result='shadowInnerInner1'/%3e %3cfeColorMatrix in='shadowInnerInner1' values='0 0 0 0 0.941176471 0 0 0 0 0.956862745 0 0 0 0 0.968627451 0 0 0 1 0'/%3e %3c/filter%3e %3c/defs%3e %3cg fill='none' fill-rule='evenodd' transform='translate(-10)'%3e %3cg transform='translate(10)'%3e %3cmask id='b' fill='%23fff'%3e %3cuse xlink:href='%23a'/%3e %3c/mask%3e %3cuse fill='%23EBF7FE' xlink:href='%23a'/%3e %3cg fill='%23459FED' mask='url(%23b)'%3e %3cg transform='translate(52 34)'%3e %3crect width='4' height='14' rx='2'/%3e %3crect width='4' height='4' y='19' rx='2'/%3e %3c/g%3e %3c/g%3e %3cg mask='url(%23b)'%3e %3cpath fill='%23459FED' d='M0 3c0-2 1-3 3-3h102c2 0 3 1 3 3v16H0V3z'/%3e %3cg transform='translate(8 7)' fill='%23EBF7FE'%3e %3ccircle cx='3' cy='3' r='3'/%3e %3ccircle cx='10' cy='3' r='3'/%3e %3ccircle cx='17' cy='3' r='3'/%3e %3c/g%3e %3cpath fill='%23EBF7FE' d='M35 10c0-2 1-3 3-3h59c2 0 3 1 3 3 0 1-1 2-3 2H38c-2 0-3-1-3-2z'/%3e %3c/g%3e %3c/g%3e %3cuse fill='%23EAF7FF' xlink:href='%23c'/%3e %3cuse fill='%23000' filter='url(%23d)' xlink:href='%23c'/%3e %3cg transform='translate(92 72)'%3e %3cuse fill='%23DAEAF3' xlink:href='%23e'/%3e %3cuse fill='%23000' filter='url(%23f)' xlink:href='%23e'/%3e %3cpath stroke='%239DD7F9' stroke-width='3' d='M28 34a4 4 0 1 0 0-9M28 25H8c-4 0-8-3-8-6V0'/%3e %3cpath fill='%23A7E3FA' d='M17 30h8c2 0 4 2 4 4s-2 4-4 4h-8v-8z'/%3e %3cpath fill='%238FD6F9' d='M17 30h3v8h-3z'/%3e %3cpath stroke='%233899EC' stroke-linecap='square' stroke-width='2' d='M18 32h-4m4 4h-4'/%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgServerErrorIcon as ReactComponent };